<template>
  <el-dialog
      v-el-drag-dialog
      :title="systemUser.systemUserID ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="user-edit"
      width="800px"
      top="5vh"
      @close="closePage">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="systemUser"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first">
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户类型" prop="userType">
                <el-select v-model="systemUser.userType" placeholder="请选择用户类型">
                  <el-option label="内部用户" :value="1"/>
                  <el-option label="外部用户" :value="2"/>
                  <el-option label="高级用户" :value="3"/>
                  <el-option label="超级管理员" :value="0"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="systemUser.userType === 1" :span="12">
              <el-form-item label="姓名" prop="tempID">
                <el-input v-model="systemUser.employeeName" placeholder="请选择" readonly>
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectEmployee.open()"/>
                </el-input>
                <employee-select ref="selectEmployee" @select="onSelectEmployee"/>
              </el-form-item>
            </el-col>
            <el-col v-if="systemUser.userType !== 2" :span="12">
              <el-form-item label="员工编号">
                <el-input v-model="systemUser.employeeNo" disabled/>
              </el-form-item>
            </el-col>
            <el-col v-if="systemUser.userType === 2" :span="12">
              <el-form-item label="外部用户类型" prop="externalUserType">
                <el-select v-model="systemUser.externalUserType" placeholder="请选择外部用户类型" @change="externalUserTypeChange">
                  <el-option label="客户" :value="1"/>
                  <el-option label="供应商" :value="2"/>
                  <el-option label="其他" :value="3"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="systemUser.externalUserType === 1 && systemUser.userType === 2" :span="12">
              <el-form-item label="客户" prop="companyName">
                <el-input v-model="systemUser.companyName" placeholder="请选择" readonly>
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectCustomer.open()"/>
                </el-input>
                <customer-select ref="selectCustomer" @select="onSelectCustomer"/>
              </el-form-item>
            </el-col>
            <el-col v-if="systemUser.externalUserType === 2 && systemUser.userType === 2" :span="12">
              <el-form-item label="供应商" prop="companyName">
                <el-input v-model="systemUser.companyName" placeholder="请选择" readonly>
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectSupplier.open()"/>
                </el-input>
                <supplier-select ref="selectSupplier" @select="onSelectSupplier"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用户名" prop="userName">
                <el-input v-model="systemUser.userName" placeholder="请输入用户名"/>
              </el-form-item>
            </el-col>
            <el-col v-if="systemUser.systemUserID === 0" :span="12">
              <el-form-item label="密码" prop="password">
                <el-input v-model="systemUser.password" type="password" placeholder="请输入密码"/>
              </el-form-item>
            </el-col>
            <el-col v-if="systemUser.systemUserID === 0" :span="12">
              <el-form-item label="确认密码" prop="confirmPd">
                <el-input v-model="systemUser.confirmPd" type="password" placeholder="请输入确认密码"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企业微信" prop="qyuserName">
                <el-input v-model="systemUser.qyuserName" placeholder="请输入企业微信用户名"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码">
                <el-input v-model="systemUser.mobile" maxlength="11" placeholder="请输入手机号"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="价格阶梯">
                <el-select v-model="systemUser.priceLevel" clearable placeholder="请选择价格阶梯">
                  <el-option label="第一阶梯" :value="10"/>
                  <el-option label="第二阶梯" :value="20"/>
                  <el-option label="第三阶梯" :value="30"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="note">
                <el-input v-model="systemUser.note" type="textarea" autosize placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="角色分配" name="second">
          <el-transfer
              v-model="systemUser.roleIds"
              filterable
              :data="roleList"
              :props="{ key: 'id', label: 'roleName' }"
              :titles="['未分配角色', '已分配角色']"/>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import SupplierSelect from "@/views/information/SupplierManage/SupplierSelect";
  import regular from "@/util/regular";
  export default {
    name: "UserEdit",
    components: { EmployeeSelect, CustomerSelect, SupplierSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        activeName: "first",
        workshopList: [],
        systemUser: {
          systemUserID: 0,
          userName: "",
          qyuserName:"",
          priceLevel: 10,
          employeeNo: "",
          employeeName: "",
          password: "",
          confirmPd: "",
          employeeID: 0,
          customerID: 0,
          companyName:"",
          companyID:"",
          externalUserType:null,
          tempID: "",
          note: "",
          userType: null,
          mobile: "",
          status: "",
          roleName: "",
          userTypeName: "",
          departmentName: "",
          workshopId: "",
          departmentId: 0,
          gender: "",
          authorityString: "",
          roleIds: [],
        },
        roleList: [],
        ruleValidate: {
          userType: { required: true, message: "请选择用户类型", trigger: "blur" },
          tempID: { required: true, message: "请选择" },
          userName: { required: true, message: "请输入用户名", trigger: "blur" },
          confirmPd: { required: true, message: "请输入确认码", trigger: "blur" },
          companyName:{ required: true, message: "请选择"},
          externalUserType:{ required: true, message: "请选择"},
          password: {
            required: true,
            pattern: regular.password,
            trigger: "blur",
            message: "6~20位,不能为纯数字或者纯字母",
          },
          mobile: {
            required: true,
            pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/,
            trigger: "blur",
            message: "请输入正确手机号",
          },
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.systemUser.systemUserID = row.systemUserID;
          this.getData();
        }
        this.getAllRole();
      },

      getWorkshopList() {
        this.$http.get("basic", "workShops/getList").then((resp) => {
          if (resp.success) {
            this.workshopList = resp.data;
          }
        });
      },

      getData() {
        this.$http.get("basic", `system/user/${this.systemUser.systemUserID}`).then((resp) => {
          if (resp.success) {
            this.systemUser = Object.assign(this.systemUser, resp.data);
          }
          this.systemUser.confirmPd = this.systemUser.password;
          if (this.systemUser.customerID > 0) {
            this.systemUser.tempID = this.systemUser.customerID;
          } else {
            this.systemUser.tempID = this.systemUser.employeeID;
          }
        });
      },

      getAllRole() {
        if (this.roleList.length === 0) {
          this.$http.get("basic", "roles/list").then((resp) => {
            if (resp.success) {
              this.roleList = resp.data;
            }
          });
        }
      },

      handleSubmit() {
        if (this.systemUser.password !== this.systemUser.confirmPd) {
          this.$message.error("请统一新密码");
          return;
        }
        const phone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!phone.test(this.systemUser.mobile) && this.systemUser.mobile) {
          this.$message({
            message: "请填写正确的手机号码！",
            type: "error",
          });
          return;
        }
        if (this.systemUser.userType == 2) {
          // this.systemUser.customerID = this.systemUser.tempID;
          this.systemUser.employeeID = this.systemUser.tempID;
        // this.systemUser.employeeID = -1;
        } else {
          this.systemUser.customerID = -1;
          this.systemUser.employeeID = this.systemUser.tempID;
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            console.log(this.systemUser);
            if (this.systemUser.systemUserID) {
              this.$http
                .put("basic", "system/user", this.systemUser)
                .then((resp) => {
                  if (resp.success) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  }
                  this.submitLoading = false;
                  this.dialogVisible = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "system/user", this.systemUser)
                .then((resp) => {
                  if (resp.success) {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.submitLoading = false;
                  this.dialogVisible = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },

      onSelectEmployee(row) {
        this.systemUser.tempID = row.employeeID;
        this.systemUser.employeeName = row.employeeName;
        this.systemUser.employeeNo = row.employeeNO;
        this.systemUser.mobile = row.mobile;
      },

      onSelectCustomer(row) {
        console.log(row);
        this.systemUser.companyName = row.customerName;
        this.systemUser.companyID = row.customerID;
      },

      onSelectSupplier(row) {
        console.log(row);
        this.systemUser.companyName = row.name;
        this.systemUser.companyID = row.pkid;
      },

      externalUserTypeChange() {
        this.systemUser.companyName = "";
        this.systemUser.companyID = "";
      }, 
      
      closePage() {
        this.systemUser.systemUserID= 0;
        this.systemUser.userName= "";
        this.systemUser.qyuserName="";
        this.systemUser.priceLevel= 10;
        this.systemUser.employeeNo= "";
        this.systemUser.employeeName= "";
        this.systemUser.password= "";
        this.systemUser.confirmPd= "";
        this.systemUser.employeeID= 0;
        this.systemUser.customerID= 0;
        this.systemUser.companyName="";
        this.systemUser.companyID="";
        this.systemUser.externalUserType=null;
        this.systemUser.tempID= "";
        this.systemUser.note= "";
        this.systemUser.userType= null;
        this.systemUser.mobile= "";
        this.systemUser.status= "";
        this.systemUser.roleName= "";
        this.systemUser.userTypeName= "";
        this.systemUser.departmentName= "";
        this.systemUser.workshopId= "";
        this.systemUser.departmentId= 0;
        this.systemUser.gender= "";
        this.systemUser.authorityString= "";
        this.systemUser.roleIds= [];
      },
    },
  };
</script>
<style lang="scss">
.user-edit {
  .el-transfer-panel {
    width: 280px;
  }
  .el-dialog .el-dialog__body {
    padding: 0 35px;
  }
}
</style>
